module.exports = __webpack_public_path__ + "img/mongodb.f71554c9.svg";